import { getDigitsCount } from '@mail/cross-sizes-utils/src';
import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as ArrowCenter } from 'img/tooltip/arrow-center.svg';
import businessImg from 'img/tooltip/flexible-quota/flexible-quota-business-tooltip.png';
import initImg from 'img/tooltip/flexible-quota/flexible-quota-init-tooltip.png';
import privateImg from 'img/tooltip/flexible-quota/flexible-quota-private-tooltip.png';
import proImg from 'img/tooltip/flexible-quota/flexible-quota-pro-tooltip.png';
import studyImg from 'img/tooltip/flexible-quota/flexible-quota-study-tooltip.png';
import React, { useState } from 'react';
import { useFirstEffect } from 'reactApp/hooks/useFirstEffect';
import { spaceFromGb } from 'reactApp/ui/FlexibleQuotaModal/FlexibleQuota.helpers';

import { TooltipContext } from '../../FlexibleQuota.constants';
import styles from './FlexibleQuotaTooltip.css';

interface FlexibleQuotaTooltipProps {
    value: number;
    context: TooltipContext;
}

const contextImages: { [key in TooltipContext]: string } = {
    init: initImg,
    private: privateImg,
    pro: proImg,
    business: businessImg,
    study: studyImg,
};

const contextTexts: { [key in TooltipContext]: string } = {
    init: 'Потяните',
    private: 'для личного ',
    pro: 'для профи',
    business: 'для бизнеса',
    study: 'для учебы',
};

export const THUMB_SATELLITE_ID = 'flexible-quota-tootip';

export function FlexibleQuotaTooltip({ value, context }: FlexibleQuotaTooltipProps) {
    const text = contextTexts[context];
    const digits = getDigitsCount(value);
    const space = spaceFromGb(value);
    const [readyClassName, setReadyClassName] = useState('');
    useFirstEffect(() => setReadyClassName(styles.ready));

    return (
        <div
            id={THUMB_SATELLITE_ID}
            data-qa-tooltip={THUMB_SATELLITE_ID}
            className={classNames(styles.root, readyClassName, {
                [styles[context]]: true,
            })}
        >
            <div className={styles.tooltip}>
                {/* TODO: исправить на прелоад как появится в 3promo */}
                {Object.values(TooltipContext).map((contextValue) => (
                    <img
                        key={contextValue}
                        src={contextImages[contextValue]}
                        alt={contextTexts[contextValue]}
                        className={classNames(styles.image, { [styles.visible]: context === contextValue })}
                    />
                ))}
                {context === 'init' ? (
                    <div className={styles.initContext}>{text}</div>
                ) : (
                    <div className={styles.info}>
                        <div className={classNames(styles.space, { [styles[`digit-${digits}`]]: true })}>
                            <Text className={styles.text}>+{space.space}</Text>
                            <Text className={styles.text}>{space.units}</Text>
                        </div>
                        <Text className={styles.context}>{text}</Text>
                    </div>
                )}
            </div>
            <div className={styles.arrow}>
                <ArrowCenter />
            </div>
        </div>
    );
}
